import {
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputText
} from 'mailup-web-components'
import { campaignState } from 'Pages/Campaign/recoil/state/campaign'

import { stepState } from 'Pages/Campaign/recoil/state/page'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const InputSenderName = () => {
  const intl = useIntl()

  const [
    {
      EmailOptions: { SenderName }
    },
    setCampaignState
  ] = useRecoilState(campaignState)

  const [
    {
      step3: {
        senderInfo: { senderNameIsDiry }
      }
    },
    setStepState
  ] = useRecoilState(stepState)

  const handleChangeName = (e) => {
    setCampaignState((prev) => ({
      ...prev,
      isDirty: true,
      EmailOptions: {
        ...prev.EmailOptions,
        SenderName: e.target.value
      }
    }))

    setStepState((prev) => ({
      ...prev,
      step3: {
        ...prev.step3,
        senderInfo: {
          ...prev.step3.senderInfo,
          senderNameIsDiry: true
        }
      }
    }))
  }
  return (
    <div>
      <FormElement
        required
        label={intl.formatMessage({ id: 'Load.Common.SenderNameLabel' })}
        feedback={
          !SenderName && senderNameIsDiry
            ? intl.formatMessage({
                id: 'Load.EmailSendingWizard.SenderNameRequired'
              })
            : undefined
        }
      >
        <InputText
          placeholder={SenderName}
          value={SenderName}
          onChange={handleChangeName}
          data-mu-test='campaign-wizard-input-SenderName'
          variant={
            SenderName === '' && senderNameIsDiry
              ? INPUT_TEXT_VARIANT_DANGER
              : null
          }
        />
      </FormElement>
    </div>
  )
}

export default InputSenderName
